interface RequestParams {
  [key: string]: string;
}

export const mainMediaMobile = '(max-width: 1024px)';
export const mainMediaTablet = '(max-width: 768px)';

export const parseSearchQuery = (searchString: string): RequestParams => {
  const result: RequestParams = {};
  const entriesIterator = new URLSearchParams(searchString).entries();
  const entries = Array.from(entriesIterator);

  entries.forEach((param) => {
    result[param[0]] = param[1];
  });

  return result;
};

export const getQueryParam = (param: string): string | null => {
  const value = parseSearchQuery(window.location.search)[param];
  if (value) {
    return value;
  }

  return null;
};

export const scrollTo = (id: string, offset?: number) => {
  const scrollOffset = offset ? offset : -200;
  const element = document.querySelector<HTMLDivElement>(id);
  if (element) {
    const y = element.getBoundingClientRect().top + window.pageYOffset + scrollOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
};

export const goToUrl = (url: string, target: 'current' | 'blank') => {
  target === 'current' ? (window.location.href = url) : window.open(url, '_blank');
};

export const toggleElement = (selector: string, state?: 'hide' | 'show') => {
  const element = document.querySelector<HTMLDivElement>(selector);
  if (!element) return;
  if (state) {
    const displayState = state === 'hide' ? 'none' : 'block';
    element.style.display = displayState;
    return;
  }
  element.style.display =
    !element.style.display || element.style.display === 'none' ? 'block' : 'none';
};

export const removeElement = (selector: string) => {
  const element = document.querySelector<HTMLDivElement>(selector);
  if (element) {
    element.remove();
  }
};
